import { E_PAGESSECTION } from './route.types';
export const pagessection = [
    {
        path: '/interpretation',
        name: E_PAGESSECTION.INTERPRETATION,
        component: () => import(/* webpackChunkName: "interpretation" */ '../../views/pagessection/Interpretation/Interpretation.vue'),
    },
    {
        path: '/selection',
        name: E_PAGESSECTION.SELECTION,
        component: () => import(/* webpackChunkName: "interpretation" */ '../../views/pagessection/Selection/Selection.vue'),
    }
];
